import { gql } from '@apollo/client';

export const GET_ADMIN_PROJECTS = gql`
    query GET_ADMIN_PROJECTS($limit: Float!, $page: Float!) {
    getAllProjectsAdmin(limit: $limit, page: $page) {
      projects {
        id
        title
        type
        createdAt
        viewCount
        isArchived
        author {
          id
          email
          userType
          avatar {
            fileUrl
          }
          profile {
            id
            name
          }
        }
      }
      page
      totalCount
    }
  }
`;